/**
 * @file Automatically generated by barrelsby.
 */

export * from './side-navigation.component';
